// extracted by mini-css-extract-plugin
export default {"root":"contract-details-wrap_root__iwX8w","tabWrap":"contract-details-wrap_tabWrap__nbxBf"};